import "./index.css"; // Global styles
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const isDevelopment = import.meta.env.DEV;

ReactDOM.createRoot(document.getElementById("root")!).render(
  isDevelopment ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
);
